import React from 'react';

function TimelineFeatureIcon(props) {
  if (
    props.item &&
    ((props.item.showInSimple && props.isSimple) ||
      (props.item.showInComplex && !props.isSimple)) &&
    ((props.item.showInExpanded && props.isExpanded) ||
      (props.item.showInCollapsed && !props.isExpanded))
  )
    return (
      <div className={props.icon + '-container'}>
        {props.icon ? (
          <img
            src={'img/' + props.icon + '.png'}
            alt={props.icon}
            className={props.icon + 'timelineIcon'}
          ></img>
        ) : (
          <div className="dotBlue"></div>
        )}
      </div>
    );
  else return null;
}

export { TimelineFeatureIcon };
